// extracted by mini-css-extract-plugin
export default {"flowsheetModuleContainer":"FlowsheetModule_flowsheetModuleContainer__a2dlM"};